import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';

//import resources
import { formatDate } from '../helpers/Helpers';
import { FaCalendarAlt } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

// //import api
import FetchData from '../api/Api';

export default function NewsDetail() {


    //get locale
    const { locale, slug } = useParams();
    const { t } = useTranslation();

    //get data
    const [data, setData] = useState(null);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/news/${slug}`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            setTimeout(function() {
                fetchData();
            }, 200)
            
        }

    }, [data, locale, slug]);


    useEffect(()=> {
        setData(null);
    }, [locale])


    return (
        <>
            <Breadcrumb title={t('news')} url='/news' subtitle={data?.data?.translations?.[0]?.title} />
            <div className='container mx-auto mt-12 px-3'>
                <div className="max-w-4xl mx-auto my-10 p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
                    {
                    
                    data === null ? 
                        <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={400} />
                    :
                    (
                        data?.data?.img ? (
                            <img 
                                className="w-full h-[400px] object-cover rounded-md mb-6"
                                src={`${process.env.REACT_APP_API_URL}/storage/uploads/news/${data.data.img}`} 
                                alt={data?.data?.translations?.[0]?.title}
                            />
                        ) : (
                           '' 
                        )
                    )
                    
                   }
                    

                    <h1 className="text-sm md:text-xl lg:text-3xl font-bold text-gray-800 mb-4">
                        {
                            data === null ?
                                <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} />
                            :
                            (
                                data?.data?.translations?.[0]?.title ? (
                                    (data.data.translations[0].title)
                                ) : (
                                    ''
                                )
                            )
                        }
                    </h1>

                    <p className="text-[12px] md:text-[13px] lg:text-sm text-gray-500 mb-6 flex items-center">
                        <FaCalendarAlt /> <strong className='mx-2'>{t('published')}:</strong> 
                        {
                            data === null ?
                                <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} width={200} />
                            :
                            (
                                data?.data?.updated_at ? (
                                    (formatDate(data.data.updated_at))
                                ) : (
                                    ''
                                )
                            )
                        }
                    </p>
                    

                    <div className="text-gray-700 leading-relaxed">
                        <div className="mb-4 text-sm lg:text-md">
                            {
                                data === null ?
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} count={5} />
                                :
                                (
                                    data?.data?.translations?.[0]?.text ? (
                                        (<p dangerouslySetInnerHTML={{ __html: data.data.translations[0].text }} />)
                                    ) : (
                                        ''
                                    )
                                )
                            }
                        </div>
                    </div>
                    
                </div>

            </div>
        </>
    );
}